// Pure placement math for the DropdownComponent JS fallback, used where CSS
// anchor positioning is unsupported. All inputs are viewport coordinates in
// pixels.
//
// - trigger: {top, left, right, bottom, width}
// - menu: {width, height}, the menu's natural (uncapped) size
// - viewport: {width, height}
// - align: "start", "end" or "center"
// - gap: space between trigger and menu
// - maxHeight: the menu's own height cap (its --_menu-max-height), if any
//
// Returns {top, left, maxHeight, side}. The menu, at its capped height, goes
// below the trigger unless it doesn't fit there and the space above is
// larger. A menu that fits neither side takes the larger one. The returned
// `maxHeight` is the smaller of the cap and that side's space. The top and
// bottom keep a `gap` margin from the viewport; `left` is clamped to the
// viewport edges.
export function fallbackPosition({
  trigger,
  menu,
  viewport,
  align = "start",
  gap = 2,
  maxHeight: cap = Infinity,
}) {
  const below = viewport.height - trigger.bottom - gap - gap;
  const above = trigger.top - gap - gap;
  const natural = Math.min(menu.height, cap);

  const side = natural > below && above > below ? "top" : "bottom";
  const maxHeight = Math.max(
    0,
    Math.min(cap, side === "bottom" ? below : above),
  );
  const height = Math.min(natural, maxHeight);

  const top =
    side === "bottom" ? trigger.bottom + gap : trigger.top - gap - height;

  let left;
  if (align === "end") {
    left = trigger.right - menu.width;
  } else if (align === "center") {
    left = trigger.left + trigger.width / 2 - menu.width / 2;
  } else {
    left = trigger.left;
  }
  left = Math.max(0, Math.min(left, viewport.width - menu.width));

  return { top, left, maxHeight, side };
}
